import React, { useState } from 'react';
import './redemption-date-modal.scss';
import { Modal, UiDatePicker, IconBtn } from '@ru-digital-assets/ui-component';

interface IRedemptionDateModal {
  open: boolean;
  onClose: () => void;
  onSubmit: (date: Date) => void;
}

export default function RedemptionDateModal({
  open,
  onClose,
  onSubmit,
}: IRedemptionDateModal) {
  const [selectedDate, setSelectedDate] = useState<Date>();

  return (
    <div className="redemption-date-modal">
      <Modal
        open={open}
        onClose={onClose}
        header={<b>Укажите дату исполнения обязательств</b>}
        body={
          <div>
            <p className="p p_font-size_14 mb_8">
              Дата исполнения обязательств
            </p>
            <UiDatePicker
              placeholderText="Дата"
              dateFormat="dd.MM.yyyy"
              onChangeRaw={(e: any) => e.preventDefault()}
              selected={!selectedDate ? undefined : selectedDate}
              onChange={(date: Date) => setSelectedDate(date)}
            />
            <div className="redemption-date-modal__controls">
              <IconBtn onClick={onClose} outlined sm title="Отмена" />
              <IconBtn
                onClick={() => onSubmit(selectedDate!)}
                disabled={!selectedDate}
                sm
                title="Подтверждаю"
              />
            </div>
          </div>
        }
      />
    </div>
  );
}
